/**
 * @module modalWindow
 */

module.exports = function() {
    const videoBtn = document.querySelectorAll( '.video-btn' );
    const modalVideo = document.getElementById( 'modalVideo' );

    //Start video play
    videoBtn.forEach( ( item ) => item.addEventListener( 'click', function( e ) {
        e.preventDefault();
        const iframeContainer = document.getElementById( 'modalVideoContainer' );
        if ( iframeContainer !== null && document.querySelector( '.embed-responsive-item' ) === null ) {
            const iframe = document.createElement( 'iframe' );
            iframe.setAttribute( 'class', 'embed-responsive-item' );
            iframe.setAttribute( 'allowscriptaccess', 'always' );
            iframe.setAttribute( 'allow', 'autoplay' );
            iframe.setAttribute( 'allowfullscreen', '' );
            iframe.setAttribute( 'src', this.dataset.src );
            iframe.onload = function() {
                const modal = new bootstrap.Modal( modalVideo, {} );
                modal.show();
            };
            iframeContainer.appendChild( iframe );
        }
    } ) );

    //Stop video play
    modalVideo.addEventListener( 'hide.bs.modal', () => {
        document.querySelector( '#modalVideoContainer > iframe' ).remove();
    } );
}; // exports